export default "__VITE_ASSET__BXMZ7PvG__"